import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PlaceButtonActionHandlerService } from '../../../betplacement/services/place-button/place-button-action-handler.service';
import { PLACE_BUTTON_MESSAGES_PROVIDER } from '../../../betplacement/services/place-button/place-button-messages-provider.service';
import {
    PLACE_BUTTON_ACTION_HANDLER_SERVICE,
    PLACE_BUTTON_ACTION_SERVICE,
    PLACE_BUTTON_DISABLE_SERVICE,
    PLACE_BUTTON_MESSAGE_SERVICE,
    PLACE_BUTTON_STATE_SERVICE,
    PLACE_BUTTON_TITLE_SERVICE,
    PLACE_BUTTON_VIEWMODEL_SERVICE,
} from '../../../betplacement/services/place-button/viewmodel/interfaces/place-button-interfaces';
import { BetslipPlaceButtonActionService } from '../../../betplacement/services/place-button/viewmodel/regular-betslip/betslip-place-button-action.service';
import { BetslipPlaceButtonDisableService } from '../../../betplacement/services/place-button/viewmodel/regular-betslip/betslip-place-button-disable.service';
import { BetslipPlaceButtonMessageService } from '../../../betplacement/services/place-button/viewmodel/regular-betslip/betslip-place-button-message.service';
import { BetslipPlaceButtonTitleService } from '../../../betplacement/services/place-button/viewmodel/regular-betslip/betslip-place-button-title.service';
import { BetslipPlaceButtonViewModelService } from '../../../betplacement/services/place-button/viewmodel/regular-betslip/betslip-place-button-viewmodel.service';
import { TeaserBetPlaceButtonMessagesProviderService } from '../../services/place-button/teaser-bet-place-button-messages-provider.service';
import { TeaserBetPlaceButtonStateService } from '../../services/place-button/teaser-bet-place-button-state.service';

@Component({
    selector: 'bs-teaser-bet-place-bet-button',
    templateUrl: './teaser-bet-place-bet-button-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: PLACE_BUTTON_STATE_SERVICE, useClass: TeaserBetPlaceButtonStateService },
        { provide: PLACE_BUTTON_MESSAGES_PROVIDER, useClass: TeaserBetPlaceButtonMessagesProviderService },
        { provide: PLACE_BUTTON_VIEWMODEL_SERVICE, useClass: BetslipPlaceButtonViewModelService },
        { provide: PLACE_BUTTON_ACTION_SERVICE, useClass: BetslipPlaceButtonActionService },
        { provide: PLACE_BUTTON_ACTION_HANDLER_SERVICE, useClass: PlaceButtonActionHandlerService },
        { provide: PLACE_BUTTON_MESSAGE_SERVICE, useClass: BetslipPlaceButtonMessageService },
        { provide: PLACE_BUTTON_TITLE_SERVICE, useClass: BetslipPlaceButtonTitleService },
        { provide: PLACE_BUTTON_DISABLE_SERVICE, useClass: BetslipPlaceButtonDisableService },
    ],
    standalone: false,
})
export class TeaserBetPlaceBetButtonContainerComponent {}
